export const ITEMIZED_INVOICE_REPORT_STATUSES_CACHE_KEY = 'itemized_invoice_report_statuses';
export const ITEMIZED_INVOICE_REPORT_STATUS_CACHE_KEY = 'itemized_invoice_report_status';
